import {
    TrendUp, Pause, Prohibit, TrendDown,
} from "@phosphor-icons/react";

export const DECISION_META = {
    BUY:   { color: "#9EE8B4", icon: TrendUp,   label: "BUY" },
    KEEP:  { color: "#9DB7F5", icon: Pause,     label: "KEEP" },
    AVOID: { color: "#F5A78D", icon: Prohibit,  label: "AVOID" },
    SELL:  { color: "#FF6B6B", icon: TrendDown, label: "SELL" },
};

export const ORDER = ["BUY", "KEEP", "AVOID", "SELL"];
